export const COMPANY = {
  ERS: { CODE: 'E2', NAME: 'Energy Rental Solutions' },
  DPS: { CODE: 'D2', NAME: 'Distributed Power Solutions' },
};
